import { Action, configureStore, ThunkAction } from "@reduxjs/toolkit";
import { authApi } from "../store/auth/authApi";
import { userAPI } from "../store/user/userApi";
import { reservationsAPI } from "../store/reservations/reservationsApi";
import { userDomAPI } from "../store/user/userDomApi";
import purchasesSlice from "../store/brokers/partner/purchases/PurchasesSlice";
import invoicesSlice from "../store/brokers/suppliers/invoices/InvoicesSlice";
import assetsSlice from "../store/brokers/partner/assets/assetsSlice";
import { companyUsersApi } from "../store/company-users/companyUsersApi";
import { googleReservationsAPI } from "../store/google-reservations/googleReservationsApi";
import { paymentsAPI } from "../store/payments/paymentsApi";
import partnersSlice from "../store/brokers/admin/partners/partnersSlice";
import agentsSlice from "../store/brokers/partner/agents/agentsSlice";
import clientsSlice from "../store/brokers/partner/clients/clientsSlice";
import integrationsSlice from "../store/brokers/partner/integrations/IntegrationsSlice";
import invoicesHotelSlice from "../store/brokers/partner/invoices/invoicesSlice";
import { xeroAPI } from "../store/xero-integration/xeroApi";
import agentActivitiesSlice from "../store/brokers/partner/agent-activities/agentActivitiesSlice";

export const store = configureStore({
  reducer: {
    [userAPI.reducerPath]: userAPI.reducer,
    [authApi.reducerPath]: authApi.reducer,
    [userDomAPI.reducerPath]: userDomAPI.reducer,
    purchases: purchasesSlice,
    invoices: invoicesSlice,
    assets: assetsSlice,
    partners: partnersSlice,
    agents: agentsSlice,
    integrations: integrationsSlice,
    clients: clientsSlice,
    hotelInvoices: invoicesHotelSlice,
    agentActivities: agentActivitiesSlice,
    [reservationsAPI.reducerPath]: reservationsAPI.reducer,
    [companyUsersApi.reducerPath]: companyUsersApi.reducer,
    [googleReservationsAPI.reducerPath]: googleReservationsAPI.reducer,
    [xeroAPI.reducerPath]: xeroAPI.reducer,
    [paymentsAPI.reducerPath]: paymentsAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      userAPI.middleware,
      authApi.middleware,
      reservationsAPI.middleware,
      companyUsersApi.middleware,
      googleReservationsAPI.middleware,
      paymentsAPI.middleware,
      xeroAPI.middleware,
    ),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
